import { configureStore, PreloadedState } from '@reduxjs/toolkit';
import { middleware as createRouterMiddleware } from '@okapi/router-connect';
import { GlobalRouter } from '@okapi/router-react';
import createSagaMiddleware, { END } from 'redux-saga';
import { createMiddleware as createCookieMiddleware } from 'isomorphic-redux-cookie-middleware';
import { rootReducer, RootState, TStateEnv } from './reducers';
import { rootSaga } from './sagas';

export type CreateStoreParams = {
  router: GlobalRouter;
  preloadedState?: PreloadedState<RootState> | {};
  host?: string;
  cookie: string;
  userAgent: string;
  env?: TStateEnv;
};

export function createStore({
  router,
  preloadedState = {},
  host = window.location.host,
  cookie,
  userAgent,
  env = {
    ORCHESTRATOR_HOST: process.env.ORCHESTRATOR_HOST,
    SELF_ORCHESTRATOR_HOST: process.env.SELF_ORCHESTRATOR_HOST,
    CONFIGURATOR_URL: process.env.CONFIGURATOR_URL,
    USE_CREDENTIALS: process.env.USE_CREDENTIALS === '1',
    requestID: '',
    apiKey: process.env.API_KEY,
    HIDE_HEADER_AND_FOOTER: process.env.HIDE_HEADER_AND_FOOTER === '1',
  },
}: CreateStoreParams) {
  const sagaMiddleware = createSagaMiddleware();
  const routerMiddleware = createRouterMiddleware(router);
  const cookieMiddleware = createCookieMiddleware();

  const store = configureStore({
    reducer: rootReducer({
      router,
      host,
      cookie,
      userAgent,
      env,
    }),
    preloadedState,
    middleware: [sagaMiddleware, routerMiddleware, cookieMiddleware],
    devTools: process.env.NODE_ENV !== 'production',
  });

  const saga = sagaMiddleware.run(rootSaga);

  return { store, close: () => store.dispatch(END), saga };
}
